import { useEffect, useState } from "react";

import DebtRecoveryServices from "../../../../services/DebtRecoveryServices";
import { formatTableData } from "./helpers";
import { PaginationProps, UseGetRequest, UseGetRequestsProps } from "./requests-types";
import { TableProps } from "../../../../components/table-simple/table.types";

const useGetRequests = ({
  mediatorCode,
  isPending,
  handleOnClickOneDebt,
}: UseGetRequestsProps): UseGetRequest => {
  const [pagination, setPagination] = useState<PaginationProps>({
    page: 1,
    showItems: 10,
    totalPages: 0,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<TableProps | null>(null);
  const [error, setError] = useState<string>("");
  const [previousMediatorCode, setPreviousMediatorCode] = useState<string>(mediatorCode);
  const [refresh, setRefresh] = useState<boolean>(true);

  const fetchData = async () => {
    setIsLoading(true);
    setError("");
    setRefresh(false);

    const response = await DebtRecoveryServices.getDebtRecoveryRequests({
      setLoading: () => {},
      loader: false,
      mediatorCode,
      isPending,
      skip: pagination.showItems * (pagination.page - 1),
      take: pagination.showItems,
    });

    if (response.ok) {
      const { items, count } = response.data;
      const tableData = formatTableData({ data: items, handleOnClickOneDebt, isPending });
      const totalPages = Math.ceil(count / pagination.showItems);
      setData(tableData);
      setPagination((prevPagination) => ({ ...prevPagination, totalPages }));
      setError("");
    } else {
      setData(null);
      setPagination({ page: 1, showItems: 10, totalPages: 0 });
      setError(response.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (mediatorCode !== previousMediatorCode) {
      setPreviousMediatorCode(mediatorCode);
      if (pagination.page !== 1) {
        setPagination((prevPagination) => ({ ...prevPagination, page: 1 }));
        return;
      }
    }
    fetchData();
  }, [mediatorCode, isPending, pagination.page]);

  useEffect(() => {
    if (refresh) {
      fetchData();
    }
  }, [refresh]);

  return {
    pagination,
    setPagination,
    isLoading,
    data,
    error,
    setRefresh,
  };
};

export default useGetRequests;
